import NoAttachments from './NoAttachments'

export default NoAttachments
